import React from 'react';
import { PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE } from '../../../js/constant-data/constants';

export function brandCSS(brand){
  return brand.replace(/([a-z])([A-Z])/g, '$1_$2').replace(' ', '_').toLowerCase();
}

export const durationMap = {
  2592000:"month",
  7884000:"quarter",
  31536000:"year"
}

export const billingMap = {
  2592000:"Monthly",
  7884000:"Quarterly",
  31536000:"Annual"
}
export const melaDurationMap = {
  2592000:"Monthly",
  7884000:"Quarterly",
  31536000:"Yearly"
}
export const subjectCodeMap = {
  Math: 'math',
  Reading: 'ela',
  'Math + Reading': 'mela'
}

export const currencyCode = {
  GBP: '&#163;',
  AUD: 'A$',
  USD: '$',
  CAD: 'C$'
}

export function amountInLocalCurrency(amount, product, showDuration, showPerYear){
  return (<><price dangerouslySetInnerHTML={{ __html: currencyCode[product.currency_code || 'USD'] + (amount/100.00).toFixed(2)}} />
  {showDuration && (showPerYear ? <span>/yr</span> : <span>/mo</span>)}</>);
}

var months = [];
var years = [], currentYear = (new Date).getUTCFullYear();

for(var i = 1; i <= 12; i++){ months.push(i)};
for(var i = currentYear; i < currentYear + 8; i++){ years.push(i)};

export const monthList = months;
export const yearList = years;

export function computePricingInfo(product, settings){
  var percentOff = null,
      monthlyAmount = parseInt(product.properties.monthly_charge),
      discountedPrice = null,
      actualPrice = null,
      actualMonthlyPrice = null,
      discountedMonthlyPrice = null,
      advertisedAmount = product.properties.advertised_amount;

  if(advertisedAmount){
    percentOff = Math.floor(
      100*(Number(advertisedAmount) - Number(product.amount)) / Number(advertisedAmount)
    );

    discountedPrice = product.amount;
    discountedMonthlyPrice = discountedPrice/12.0;
  }else{
     if((settings.couponRedeemable && settings.couponRedeemable[1]) || ( settings.isSemUser && settings.coupon )){
        percentOff = settings.coupon.stripe_id===PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE && (!settings.eligible_product_codes.includes(product.code)) ? 0 : settings.coupon.percent_off;
        discountedPrice = (product.amount * (100 - percentOff) / 100.0);
        discountedMonthlyPrice = (monthlyAmount * (100 - percentOff) / 100.0);
     }
  }
  if(advertisedAmount){
    actualPrice = advertisedAmount;
    actualMonthlyPrice = advertisedAmount/12.0;
  }else{
    actualPrice = product.amount;
    actualMonthlyPrice = monthlyAmount;
  }

  return {
    percentOff: percentOff,
    actualPrice: actualPrice,
    discountedPrice: discountedPrice,
    actualMonthlyPrice: actualMonthlyPrice,
    discountedMonthlyPrice: discountedMonthlyPrice
  }
}

export function buildProductGroups(products){
  var result = {};
  var productList = products.sort(function(x,y){ return x.credit_count - y.credit_count});

  productList.map(function(product){
    result[product.credit_count] = result[product.credit_count] || [];
    result[product.credit_count].push(product);
  });

  Object.keys(result).map(function(key){
    result[key] = result[key].sort(function(x,y){ return y.amount - x.amount});
  })

  return result;
};

export const convertSecondsToDays = seconds =>{
  if(seconds)
    return (seconds / 86400);
  return null;
}

